window.siteUrl = function (params) {
    return window.baseUrl + params;
};

/**
 * Kanban em produção: o HTML pode ser servido em outro host (ex.: pipeline.develop.eloca.com.br
 * via CloudFront/S3) enquanto `baseUrl` aponta para o app Laravel. Requisições cross-origin
 * precisam de credentials para enviar o cookie de sessão; sem isso o painel responde 401.
 */
(function () {
    if (typeof window.baseUrl !== "string" || !window.baseUrl) {
        return;
    }
    try {
        var appOrigin = new URL(window.baseUrl).origin;
        if (window.location.origin === appOrigin) {
            return;
        }
        if (typeof $ !== "undefined" && $.ajaxSetup) {
            $.ajaxSetup({
                xhrFields: {
                    withCredentials: true,
                },
            });
        }
        if (window.axios && window.axios.defaults) {
            window.axios.defaults.withCredentials = true;
        }
    } catch (e) {
        // baseUrl inválido — ignora
    }
})();

window.resizeIFrame = function (id) {
    var height = $(document).height();

    // Backwards – send message to parent
    window.parent.postMessage(
        [
            "setHeightIFrame",
            {
                height: height,
                id: id,
            },
        ],
        "*"
    );
};

window.resizeIframe2 = function (iframe) {
    iframe.style.height =
        iframe.contentWindow.document.body.scrollHeight + "px";
};

window.showToastSuccess = function (context, msg) {
    if (msg == '' || msg == undefined) {
        msg = 'As alterações foram salvas com sucesso.';
    }
    $(".js-show-toast.toast__success .js-toast-message", context).html(msg);
    $(".js-show-toast.toast__success", context).toast("show");
}

window.showToastDanger = function (context, msg) {
    if (msg == '' || msg == undefined) {
        msg = 'Não foi possível salvar as alterações.';
    }
    $(".js-show-toast.toast__danger .js-toast-message", context).html(msg);
    $(".js-show-toast.toast__danger", context).toast("show");
}

window.showToastWarning = function (context, msg) {
    if (msg == "" || msg == undefined) {
        msg = "Tente novamente.";
    }
    $(".js-show-toast.toast__warning .js-toast-message", context).html(msg);
    $(".js-show-toast.toast__warning", context).toast("show");
}
